<template>
  <div 
    id="nutrients_water_ship"
    class="nutrients_water"
  >
    <div 
      v-if="receivedData"
      class="nutrients_water-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="line"
          index-axis="x"
          :id="'nutrients_water_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
    <div 
      v-if="receivedData"
      class="nutrients_water-item"
    >
      <CastomGraphic
          :received-data="receivedData[1]"
          graph-type="line"
          index-axis="x"
          :id="'nutrients_water_ship-2'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'NutrientsWater',
  
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'nutrients_water',
      cloneElementId: 'nutrients_water_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '86,87').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>